// extracted by mini-css-extract-plugin
module.exports = {"copy_wrapper":"style_copy_wrapper___bW79","result_list":"style_result_list__3f6gB","result_item":"style_result_item__1AbAn"};